export default __webpack_public_path__ + "static/media/nepal_powerline_distribution.0b6a00b6.png";